import React, { useMemo, Fragment } from 'react';
import PropTypes from 'prop-types';

import DismissButton from '../../../../components/global/DismissButton';
import Button from '../../../../components/global/Button';

const propTypes = {
  printBackgrounds: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      asset_image: PropTypes.shape({
        id: PropTypes.string,
        url: PropTypes.string,
      }),
    }),
  ).isRequired,
  onPrintBackgroundSelect: PropTypes.func.isRequired,
  onClose: PropTypes.func,
};

const PrintBackgroundSelector = ({
  printBackgrounds,
  onPrintBackgroundSelect,
  onClose,
}) => {
  const portraitBackgrounds = useMemo(
    () =>
      printBackgrounds.filter(
        ({ asset_image: image }) => image?.height > image?.width,
      ),
    [printBackgrounds],
  );
  const landscapeBackgrounds = useMemo(
    () =>
      printBackgrounds.filter(
        ({ asset_image: image }) => image?.width >= image?.height,
      ),
    [printBackgrounds],
  );

  return (
    <Fragment>
      <div className="print-background-selector-header">
        <h3 className="print-background-selector-header-title">
          Select a backdrop
        </h3>
        <DismissButton onClick={onClose} absolute />
      </div>
      <div className="print-background-selector-container">
        {portraitBackgrounds.length > 0 && (
          <Fragment>
            <p className="text-white mb-0">PORTRAIT BACKDROPS</p>
            <hr className="mt-0" />
            <div className="print-background-selector-grid mb-3">
              {portraitBackgrounds.map(printBackground => (
                <Button
                  key={printBackground.id}
                  btnStyle="reset"
                  className="print-background-selector-item"
                  onClick={() => onPrintBackgroundSelect({ printBackground })}
                >
                  <figure
                    style={{
                      backgroundImage: `url("${printBackground.asset_image.url}")`,
                    }}
                  />
                </Button>
              ))}
            </div>
          </Fragment>
        )}
        {landscapeBackgrounds.length > 0 && (
          <Fragment>
            <p className="text-white mb-0">LANDSCAPE BACKDROPS</p>
            <hr className="mt-0" />
            <div className="print-background-selector-grid">
              {landscapeBackgrounds.map(printBackground => (
                <Button
                  key={printBackground.id}
                  btnStyle="reset"
                  className="print-background-selector-item landscape"
                  onClick={() => onPrintBackgroundSelect({ printBackground })}
                >
                  <figure
                    style={{
                      backgroundImage: `url("${printBackground.asset_image.url}")`,
                    }}
                  />
                </Button>
              ))}
            </div>
          </Fragment>
        )}
      </div>
    </Fragment>
  );
};

PrintBackgroundSelector.propTypes = propTypes;

export default PrintBackgroundSelector;
